// Generates a branded, Instagram-ready score card (1080x1080 PNG) and returns a data URL.
const SITE = typeof window !== "undefined" ? window.location.host : "realestatewithayush.com";

function fitFont(ctx, text, maxW, startPx, weight = "800", family = "Manrope, sans-serif") {
  let px = startPx;
  do {
    ctx.font = `${weight} ${px}px ${family}`;
    if (ctx.measureText(text).width <= maxW) break;
    px -= 8;
  } while (px > 40);
  return px;
}

function loadImg(src) {
  return new Promise((resolve) => {
    const im = new Image();
    im.crossOrigin = "anonymous";
    im.onload = () => resolve(im);
    im.onerror = () => resolve(null);
    im.src = src;
  });
}

export async function generateScoreCard({ score, total, level = "", title = "Smart Buyer Quiz" }) {
  try { await document.fonts.ready; } catch (e) { /* ignore */ }
  const avatar = await loadImg(`${process.env.PUBLIC_URL}/ayush-avatar.jpg`);

  const S = 1080;
  const c = document.createElement("canvas");
  c.width = S; c.height = S;
  const x = c.getContext("2d");

  // background
  x.fillStyle = "#141414";
  x.fillRect(0, 0, S, S);
  x.strokeStyle = "#2e2e2e";
  x.lineWidth = 2;
  x.strokeRect(56, 56, S - 112, S - 112);
  x.textBaseline = "top";

  // brand
  x.fillStyle = "#ffffff";
  x.font = '800 36px Manrope, sans-serif';
  x.fillText("REAL ESTATE", 104, 104);
  x.fillStyle = "#8a8a8a";
  x.fillText("WITH AYUSH", 104, 150);

  // avatar (top-right, circular with white ring)
  if (avatar) {
    const cx = S - 190, cy = 172, r = 74;
    x.save();
    x.beginPath(); x.arc(cx, cy, r, 0, Math.PI * 2); x.closePath(); x.clip();
    x.drawImage(avatar, cx - r, cy - r, r * 2, r * 2);
    x.restore();
    x.strokeStyle = "#ffffff"; x.lineWidth = 5;
    x.beginPath(); x.arc(cx, cy, r, 0, Math.PI * 2); x.stroke();
  }

  // accent tick
  x.fillStyle = "#ffffff";
  x.fillRect(104, 320, 84, 6);

  // "I SCORED"
  x.fillStyle = "#8a8a8a";
  x.font = '500 30px "JetBrains Mono", monospace';
  x.fillText("I SCORED", 104, 360);

  // big score
  const scoreText = `${score}/${total}`;
  x.fillStyle = "#ffffff";
  const px = fitFont(x, scoreText, S - 208, 300);
  x.font = `800 ${px}px Manrope, sans-serif`;
  x.fillText(scoreText, 100, 410);

  // title
  x.fillStyle = "#ffffff";
  x.font = '800 46px Manrope, sans-serif';
  x.fillText(title.toUpperCase(), 104, 748);

  // level pill
  if (level) {
    x.font = '500 28px "JetBrains Mono", monospace';
    x.fillStyle = "#8a8a8a";
    x.fillText(`${level.toUpperCase()} LEVEL`, 104, 806);
  }

  // footer
  x.fillStyle = "#ffffff";
  x.font = '700 32px "JetBrains Mono", monospace';
  x.fillText(SITE, 104, S - 172);
  x.fillStyle = "#8a8a8a";
  x.font = '500 26px "JetBrains Mono", monospace';
  x.fillText("Play the free first-time buyer quiz", 104, S - 126);

  return c.toDataURL("image/png");
}

export const SHARE_SITE = typeof window !== "undefined" ? window.location.origin : `https://${SITE}`;
